interface ListToStringOptions {
  /** Whether to include the word "and" before the final item. Default true. */
  includeAnd?: boolean;
  /**
   * Optional replacement text to use in place of 'and', for example:
   * ```typescript
   *   listToString(['a', 'b'], { and: '&' }); // 'a & b'
   * ```
   */
  and?: string;
  /**
   * Whether to show include an oxford comma or not. Default false.
   */
  oxfordComma?: boolean;
  /**
   * Optional string to replace the comma as a joiner. For instance:
   * ```typescript
   *   const relatives = ['David, his father', 'Steven, his uncle', 'Elaine, his wife'];
   *   listToString(relatives, { joiner: ';', oxfordComma: true });
   *   // 'David, his father; Steven, his uncle; and Elaine, his wife'
   * ```
   */
  joiner?: string;
  /**
   * Whether to leave a space between items when joined. Defaults true.
   */
  joinerSpace?: boolean;
}

/**
 * Convert an array into a readable list, with configurable joiners, etc...
 */
export function listToString(
  list: any[],
  {
    and = 'and',
    includeAnd = true,
    oxfordComma = false,
    joiner = ',',
    joinerSpace = true,
  }: ListToStringOptions = {}
): string {
  if (!list.length) return '';
  if (list.length === 1) return `${list[0]}`;
  if (list.length === 2) {
    if (includeAnd) {
      return list.join(`${joinerSpace ? ' ' : ''}${and}${joinerSpace ? ' ' : ''}`);
    }
    return list.join(joiner + (joinerSpace ? ' ' : ''));
  }
  let text = list.slice(0, -1).join(`${joiner}${joinerSpace ? ' ' : ''}`);
  if (oxfordComma) text += joiner;
  if (joinerSpace) text += ' ';
  if (includeAnd) text += and + (joinerSpace ? ' ' : '');
  text += `${list[list.length - 1]}`;
  return text;
}

export function listToStringReducerFactory(options: ListToStringOptions = {}) {
  return function meanReducer<T>(accum: string, currentValue: T, index: number, arr: T[]): string {
    const isLastItem = arr.length - 1 === index;
    return isLastItem ? listToString(arr, options) : '';
  };
}
